<template>
  <div class="MerchantNo">
    <div class="content">
      <div class="item">
        <span class="title">商户号id</span>
        <el-input v-model="parameter.merchant_id" placeholder="请输入内容" style="width: 300px" />
      </div>
      <div class="item">
        <span class="title">商户号名称</span>
        <el-input v-model="parameter.merchant_name" placeholder="请输入内容" style="width: 300px" />
      </div>
      <div class="item">
        <span class="title">APIv2密钥</span>
        <el-input v-model="parameter.certificate_serial" placeholder="请输入内容" style="width: 300px" />
      </div>
      <div class="item">
        <span class="title">证书文件路径</span>
        <!-- <el-input v-model="parameter.certificate_file_path" placeholder="请输入内容" style="width: 200px" /> -->
        <div v-if="name" style="margin-right:10px">
          <el-tag>{{ name }}</el-tag>
        </div>
        <el-button type="primary" :disabled="!parameter.merchant_id" size="mini" @click="$refs.file.click()">上传证书<input ref="file" style="display:none;" type="file" multiple accept=".pem" @change="uploadPictures"></el-button>
      </div>
      <div class="item">
        <span class="title">秘钥文件路径</span>
        <!-- <el-input v-model="parameter.private_key_file_path" placeholder="请输入内容" style="width: 200px" /> -->
        <div v-if="siminame" style="margin-right:10px">
          <el-tag>{{ siminame }}</el-tag>
        </div>
        <el-button :disabled="!parameter.merchant_id" type="primary" size="mini" @click="$refs.files.click()">上传密钥<input ref="files" style="display:none;" type="file" multiple accept=".pem" @change="uploadPicturesr"></el-button>
      </div>

    </div>
    <div style="text-align: end; margin-top: 33px;">
      <el-button @click="$emit('close')">取消</el-button>
      <el-button type="primary" @click="$emit('determine', parameter)">确定</el-button>
    </div>
  </div>
</template>

<script>
import { uploadcert } from '@/api/ladderdiagram.js'
export default {
  data() {
    return {
      parameter: {
        merchant_id: null, // 商户号id
        merchant_name: null, // 商户号名称
        certificate_serial: null, // 证书序列号
        certificate_file_path: null, // 证书文件路径
        private_key_file_path: null // 秘钥文件路径
      },
      name: null,
      siminame: null
    }
  },
  methods: {
    // 上传图片回调 图片(不是裁剪上传)
    async uploadPictures(e) {
      console.log('e.target.files', e.target.files)
      // eslint-disable-next-line eqeqeq
      const extension = e.target.files[0].name.split('.').slice(-1) == 'pem'
      if (!extension) {
        this.$message.warning('上传模板只能是pem格式!')
        return
      }
      const form = new FormData()
      form.append('file', e.target.files[0])
      form.append('merchant_id', this.parameter.merchant_id)
      form.append('type', 1)
      // const file = e.target.files
      const data = await uploadcert(form)
      this.name = e.target.files[0].name
      console.log('data', data)
      this.parameter.certificate_file_path = data.data.path
      // console.log('e', e, e.target.files[0])
      // const fileIfon = e.target.files[0]
    },

    // 上传图片回调 图片(不是裁剪上传)
    async uploadPicturesr(e) {
      console.log('e.target.files', e.target.files)
      // eslint-disable-next-line eqeqeq
      const extension = e.target.files[0].name.split('.').slice(-1) == 'pem'
      if (!extension) {
        this.$message.warning('上传模板只能是pem格式!')
        return
      }
      const form = new FormData()
      form.append('file', e.target.files[0])
      form.append('merchant_id', this.parameter.merchant_id)
      form.append('type', 2)
      // const file = e.target.files
      const data = await uploadcert(form)
      this.siminame = e.target.files[0].name
      console.log('data', data)
      this.parameter.private_key_file_path = data.data.path
      // console.log('e', e, e.target.files[0])
      // const fileIfon = e.target.files[0]
    }

  }
}
</script>

<style scoped>
.MerchantNo{

}

.content{

}

.item{
margin-bottom: 10px;
display: flex;
align-items: center;
}

.title{
    display: inline-block;
    width: 142px;
}
</style>
